module.exports = __webpack_public_path__ + "img/Ballast-Drawing-FG-584x584.84446bd8.png";